/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  IInventoryDetailMethods,
  InventoryDetailService,
  IStaticPageContentMethods,
  StaticPageContentService,
} from "./components";

export type InventoryDetailViewPageAgent = IHeaderMethods &
  IStaticPageContentMethods &
  IInventoryDetailMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new InventoryDetailService(),
  ];
};

export const getAgent = () => {
  return createAgent<InventoryDetailViewPageAgent>({
    plugins: getPlugins(),
  });
};
